<script setup>
import { t } from '../i18n';

// Four buttons (phone: square) in their own row under the total card (docs/design/SPEC.md, decisions 24 and 33):
// operations, payouts, analytics and achievements (docs/achievements/SPEC.md) — screens inside the «Портфель» tab.
defineProps({
  // Desktop: one framed card, four 100 px high buttons across its full width.
  desktop: {
    type: Boolean,
    default: false,
  },
});

// The section to open: 'operations' | 'cashflow' | 'analytics' | 'achievements'.
const emit = defineEmits(['navigate', 'soon']);

const ITEMS = [
  { key: 'operations', label: 'home.operations', icon: 'M7 4v16M3.5 7.5 7 4l3.5 3.5M17 20V4M13.5 16.5 17 20l3.5-3.5' },
  { key: 'cashflow', label: 'home.payouts', icon: 'M4.5 6.5h15v13h-15zM4.5 10.5h15M8.5 4v4M15.5 4v4' },
  { key: 'analytics', label: 'home.analytics', icon: 'M12 3.5a8.5 8.5 0 1 0 8.5 8.5H12zM15 3.9A8.5 8.5 0 0 1 20.1 9H15z' },
  { key: 'achievements', label: 'home.achievements', icon: 'M8 4.5h8v5a4 4 0 0 1-8 0zM8 6.5H5v1.5a3 3 0 0 0 3 3M16 6.5h3v1.5a3 3 0 0 1-3 3M12 13.5v3.5M9.5 17h5v3h-5z' },
];

function go(item) {
  if (item.key === 'achievements') {
    emit('soon', t('common.inDevelopment'));
    return;
  }
  emit('navigate', item.key);
}
</script>

<template>
  <div
    class="grid"
    :class="desktop
      ? 'grid-cols-4 gap-3 rounded-lg border border-slate-700 bg-slate-900/40 p-3'
      : 'grid-cols-4 gap-2'"
  >
    <button
      v-for="item in ITEMS"
      :key="item.key"
      type="button"
      class="flex flex-col items-center justify-center p-3 text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
      :class="item.key === 'achievements'
        ? desktop
          ? 'h-[100px] gap-2 rounded-md bg-slate-800/50 opacity-50'
          : 'aspect-square gap-1.5 rounded-2xl bg-slate-900 px-1 opacity-50'
        : desktop
          ? 'h-[100px] gap-2 rounded-md bg-slate-800/50 hover:bg-slate-800'
          : 'aspect-square gap-1.5 rounded-2xl bg-slate-900 px-1 active:bg-slate-800'"
      :aria-disabled="item.key === 'achievements' ? 'true' : undefined"
      @click="go(item)"
    >
      <svg
        class="text-slate-400"
        :class="desktop ? 'size-8' : 'size-[30px]'"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path :d="item.icon" />
      </svg>
      <span
        class="max-w-full truncate font-medium leading-[1.125rem] text-slate-200"
        :class="desktop ? 'text-sm' : 'text-[0.75rem]'"
      >{{ t(item.label) }}</span>
    </button>
  </div>
</template>
